<template>
  <div class="animated fadeIn">
      <h4 class="card-title">Contractor <b>Details</b></h4>
      <b-form-row class="form-detail">
        <b-col sm="6">
          <b-form-group
            label="First Name"
            label-for="firstName"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{tenant.firstName}}</label>
          </b-form-group>
          <b-form-group
            label="LastName"
            label-for="lastName"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{tenant.lastName}}</label>
          </b-form-group>
          <b-form-group
            label="Gender"
            label-for="gender"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{tenant.gender}}</label>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Phone"
            label-for="phone"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{tenant.phone}}</label>
          </b-form-group>
          <b-form-group
            label="Mobile"
            label-for="mobile"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{tenant.mobile}}</label>
          </b-form-group>
          <b-form-group
            label="Email"
            label-for="email"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{tenant.email}}</label>
          </b-form-group>
          <hr />
          <b-form-group
            label="Created Time"
            label-for="createdAt"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{tenant.createdAt}}</label>
          </b-form-group>
          <b-form-group
            label="Updated Time"
            label-for="updatedAt"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{tenant.updatedAt}}</label>
          </b-form-group>
        </b-col>
      </b-form-row>
      <div slot="footer">
        <b-row>
          <b-col md="6" lg="3" class="d-md-down-none">
            <b-button
                  @click="goBack()"
                  size="md"
                  variant="light"
                  class="btn-pill">
              <i class="fa fa-arrow-left"></i> Back
            </b-button>
          </b-col>
        </b-row>
      </div>
  </div>
</template>

<script>
import cServerTable from '@/views/components/cServerTable'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'tenantDetail',
  components: {
    axios,
    cServerTable
  },
  data () {
    // table config
    let billingTableconfig = cServerTable.methods.setTableConfig({
      columns: [
        'billingCycle',
        'period',
        'title',
        'issuedBy',
        'dueDate',
        'billingStatus',
        'billingDetailButton'
      ],
      options: {
        headings: {
          'period': 'Period',
          'title': 'Title',
          'issuedBy': 'Issued By',
          'dueDate': 'Due Date',
          'billingCycle': 'Cycle',
          'billingStatus': 'Status',
          'billingDetailButton': ''
        },
        sortable: [],
        uniqueKey: 'uuid',
        templates: {
          dueDate (h, row) {
            return row.dueDate !== null ? moment(row.dueDate).format(window.AppConfig.dateFormat) : '-'
          }
        }
      }
    }, 'billing')

    let visitorTableconfig = cServerTable.methods.setTableConfig({
      columns: [
        'name',
        'typeText',
        'visitStartTime',
        'visitEndTime',
        'visitorStatus',
        'createdAt',
        'actionButtonsVisitorTenant3'
      ],
      options: {
        headings: {
          name: 'Name',
          typeText: 'Visitor Type',
          visitStartTime: 'Check In Time',
          visitEndTime: 'Check Out Time',
          visitorStatus: 'Status',
          createdAt: 'Requested Time',
          actionButtonsVisitorTenant3: ''
        },
        sortable: ['name', 'createdAt', 'visitStartTime', 'visitEndTime'],
        uniqueKey: 'uuid',
        params: {
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          visitor_status_uuid: this.$route.query.visitor_status_uuid,
          visitor_type_uuid: this.$route.query.visitor_type_uuid
        },
        templates: {
          createdAt (h, row) {
            return row.createdAt !== null ? moment(row.createdAt).format(window.AppConfig.dateFormat) : '-'
          },
          visitStartTime (h, row) {
            return row.visitStartTime !== null ? moment(row.visitStartTime).format(window.AppConfig.dateFormat) : '-'
          },
          visitEndTime (h, row) {
            return row.visitEndTime !== null ? moment(row.visitEndTime).format(window.AppConfig.dateFormat) : '-'
          }
        }
      }
    }, 'visitor')

    let complaintTableconfig = cServerTable.methods.setTableConfig({
      columns: [
        'place',
        'description',
        'complainStatus',
        'createdAt',
        'actionButtonsComplaintTenant3'
      ],
      options: {
        headings: {
          place: 'Location',
          description: 'Description',
          complainStatus: 'Status',
          createdAt: 'Created Time',
          actionButtonsComplaintTenant3: ''
        },
        sortable: ['createdAt'],
        uniqueKey: 'uuid',
        params: {
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          complain_status_uuid: this.$route.query.complain_status_uuid,
          complain_category_uuid: this.$route.query.complain_category_uuid
        },
        templates: {
          createdAt (h, row) {
            return row.createdAt !== null ? moment(row.createdAt).format(window.AppConfig.dateFormat) : '-'
          },
          userProfile (h, row) {
            return row.userProfile.firstName + ' ' + window.setDefaultNull(row.userProfile.lastName)
          }
        }
      }
    }, 'complain')

    let requestTableconfig = cServerTable.methods.setTableConfig({
      columns: [
        'title',
        'address',
        'requestCategory',
        'requestStatus',
        'createdAt',
        'actionButtonsRequestTenant3'
      ],
      options: {
        headings: {
          title: 'Title',
          address: 'Address',
          requestCategory: 'Category',
          requestStatus: 'Status',
          createdAt: 'Requested Time',
          actionButtonsRequestTenant3: ''
        },
        sortable: ['createdAt'],
        uniqueKey: 'uuid',
        params: {
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          request_status_uuid: this.$route.query.request_status_uuid,
          request_category_uuid: this.$route.query.request_category_uuid,
          address: this.$route.query.search
        },
        templates: {
          createdAt (h, row) {
            return row.createdAt !== null ? moment(row.createdAt).format(window.AppConfig.dateFormat) : '-'
          },
          account (h, row) {
            return window.setDefaultNull(row.account.name)
          },
          requestedBy (h, row) {
            return window.setDefaultNull(row.requestedBy.name)
          },
          address (h, row) {
            return window.setDefaultNull(row.requestedBy.address)
          }
        }
      }
    }, 'request')

    let bookingTableconfig = cServerTable.methods.setTableConfig({
      columns: [
        'facility',
        'startTime',
        'endTime',
        'facilityBookingStatus',
        'createdAt',
        'actionButtonsBookingTenant3'
      ],
      options: {
        headings: {
          facility: 'Site',
          startTime: 'Start Time',
          endTime: 'End Time',
          facilityBookingStatus: 'Status',
          createdAt: 'Requested Time',
          actionButtonsBookingTenant3: ''
        },
        sortable: ['startTime', 'endTime', 'createdAt'],
        uniqueKey: 'uuid',
        params: {
          start_time: this.$route.query.startTime,
          end_time: this.$route.query.endTime,
          facility_booking_status_uuid: this.$route.query.facility_booking_status_uuid,
          facility_uuid: this.$route.query.facility_uuid
        },
        templates: {
          createdAt (h, row) {
            return row.startTime !== null ? moment(row.createdAt).format(window.AppConfig.dateFormat) : '-'
          },
          startTime (h, row) {
            return row.startTime !== null ? moment(row.startTime).format(window.AppConfig.dateFormat) : '-'
          },
          endTime (h, row) {
            return row.startTime !== null ? moment(row.endTime).format(window.AppConfig.dateFormat) : '-'
          },
          userProfile (h, row) {
            return row.userProfile.firstName + ' ' + window.setDefaultNull(row.userProfile.lastName)
          }
        }
      }
    }, 'facilityBooking')

    const cServerTableConfig = cServerTable.methods.setTableConfig({
      columns: [
        'createdAt',
        'changedBy',
        'note',
        'isActiveStatusHistory'
      ],
      options: {
        headings: {
          createdAt: 'Date Time',
          changedBy: 'Changed By',
          note: 'Note',
          isActiveStatusHistory: 'Action'
        },
        uniqueKey: 'uuid',
        params: {
          user_profile_uuid: this.$route.params.id
        },
        templates: {
          createdAt (h, row) {
            return row.createdAt !== null ? moment(row.createdAt).format(window.AppConfig.dateFormat) : '-'
          }
        }
      }
    }, 'userActivatedLog')

    return {
      apiUrlGetDetail: window.AppConfig.apiUrl + 'profile',
      apiUrlGetStatusHistories: window.AppConfig.apiUrl + 'user-activated-log',
      apiUrlGetChildTenant: window.AppConfig.apiUrl + 'profile?role=contractor&parent=',
      apiUrlGetBillings: window.AppConfig.apiUrl + 'billing?user_profile_uuid=',
      apiUrlGetVisitors: window.AppConfig.apiUrl + 'visitor?ascending=1&requestedBy=',
      apiUrlGetComplaints: window.AppConfig.apiUrl + 'complain?ascending=1&userProfile=',
      apiUrlRequests: window.AppConfig.apiUrl + 'request?ascending=1&requestedBy=',
      apiUrlGetFacilityBookings: window.AppConfig.apiUrl + 'facility-booking?ascending=1&userProfile=',
      apiUrl: window.AppConfig.apiUrl + 'request',
      tenant: {
        uuid: null,
        firstName: null,
        lastName: null,
        gender: null,
        dob: null,
        phone: null,
        mobile: null,
        address: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        username: null,
        email: null,
        parent: null,
        relation: null,
        createdAt: null,
        updatedAt: null,
        identityNumber: null,
        identityType: null,
        nationality: null,
        bloodType: null,
        unit: null
      },
      childTenant: [],
      columns: cServerTableConfig.columns,
      options: cServerTableConfig.options,
      billings: [],
      billingTableColumns: billingTableconfig.columns,
      billingTableOptions: billingTableconfig.options,
      visitors: [],
      visitorTableColumns: visitorTableconfig.columns,
      visitorTableOptions: visitorTableconfig.options,
      complaints: [],
      complaintTableColumns: complaintTableconfig.columns,
      complaintTableOptions: complaintTableconfig.options,
      requests: [],
      requestTableColumns: requestTableconfig.columns,
      requestTableOptions: requestTableconfig.options,
      bookings: [],
      bookingTableColumns: bookingTableconfig.columns,
      bookingTableOptions: bookingTableconfig.options,
      filterBy: {
        DateTime: window.setDefaultNull(this.$route.query.start_date) === null ? null : [window.setDefaultNull(this.$route.query.start_date), window.setDefaultNull(this.$route.query.end_date)],
        requestStatusList: [],
        requestCategoryList: [],
        request_status_uuid: window.setDefaultNull(this.$route.query.request_status_uuid),
        request_category_uuid: window.setDefaultNull(this.$route.query.request_category_uuid),
        DateTimeNotAfter: moment().format('YYYY-MM-DD'),
        address: window.setDefaultNull(this.$route.query.address)
      }
    }
  },
  mounted () {
    this.getDetailInfo()
    this.getChildTenant()
  },
  watch: {
    '$route.params.id': function (id) {
      this.getDetailInfo()
    }
  },
  methods: {
    getDetailInfo () {
      axios.get(this.apiUrlGetDetail + '/' + this.$route.params.id)
        .then(response => {
          window.setDetailValue(this.tenant, response.data)
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          window.history.back()
        })
    },
    getChildTenant () {
      axios.get(this.apiUrlGetChildTenant + this.$route.params.id)
        .then(response => {
          this.childTenant = response.data._embedded.profile
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        })
    },
    getStatusColor (status) {
      if (status) {
        return 'success'
      } else {
        return 'secondary'
      }
    },
    getStatusColorVisitor (status) {
      switch (status) {
        case 'Check In':
          return 'success'
        case 'Check Out':
          return 'secondary'
        case 'Registered':
          return 'primary'
        default:
          return 'dark'
      }
    },
    getStatusColorComplaint (status) {
      switch (status) {
        case 'Pending':
          return 'warning'
        case 'In Progress':
          return 'primary'
        case 'Resolved':
          return 'success'
        default:
          return 'danger'
      }
    },
    getStatusColorRequest (status) {
      switch (status) {
        case 'Pending':
          return 'warning'
        case 'Approved':
          return 'success'
        default:
          return 'danger'
      }
    },
    getStatusColorBooking (value) {
      switch (value) {
        case 'Requested':
          return 'primary'
        case 'Rejected':
          return 'danger'
        case 'Approved':
          return 'success'
        case 'Check In':
          return 'info'
        case 'Check Out':
          return 'dark'
        case 'Cancelled':
          return 'warning'
        default:
          return 'light'
      }
    },

    getTypeColorVisitor (type) {
      switch (type) {
        case 'Friend':
          return 'success'
        case 'Sub Contractor':
          return 'light'
        case 'Family':
          return 'primary'
        default:
          return 'dark'
      }
    },

    getCycleColor (val) {
      switch (val) {
        case 'First':
          return 'primary'
        case 'Second':
          return 'info'
        case 'Third':
          return 'secondary'
        default:
          return 'light'
      }
    },

    getFlagColor (val) {
      switch (val) {
        case 'Overdue':
          return 'danger'
        case 'Dispute':
          return 'warning'
        default:
          return 'transparent'
      }
    },

    getBillingStatusColor (val) {
      switch (val) {
        case 'Paid':
          return 'success'
        case 'Pending':
          return 'warning'
        case 'New':
          return 'primary'
        case 'Refunded':
          return 'info'
        case 'Cancelled':
          return 'danger'
        default:
          return 'secondary'
      }
    },

    isAnyParent () {
      return this.tenant.parent !== null && this.tenant.parent !== ''
    },

    doRequestApproval (row, status, note) {
      if (status === 'Rejected' && note === '') { // eslint-disable-line
        this.$alertify.error('Can\'t Update. Reject Note is Required.')
        return false
      } else {
        let listStatus = this.filterBy.requestStatusList
        let uuidStatus = null
        for (let i = 0; i < listStatus.length; i++) {
          if (listStatus[i].text === status) uuidStatus = listStatus[i].value
        }
        axios.patch(this.apiUrl + '/' + row.uuid,
          {
            requestStatus: uuidStatus,
            note: note
          }
        )
          .then(response => {
            this.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + status + '</b>')
            row.requestStatus = status
          })
          .catch(error => {
            this.$store.dispatch('errorMessage', error)
              .then(errMsg => {
                this.$alertify.error(errMsg)
              })
          })
      }
    },
    doConfirmRejecting (row) {
      this.$alertify.prompt('Reject Note <span style="color:red">*</span>', '',
        (evt, value) => this.doRequestApproval(row, 'Rejected', value)
      )
    },
    doBookingApprovalBooking (row, status, note) {
      if (status === 'Rejected' && note === '') { // eslint-disable-line
        this.$alertify.error('Can\'t Update. Reject Note is Required.')
        return false
      } else {
        let listStatus = this.filterBy.facilityBookingStatusList
        let uuidStatus = null
        for (let i = 0; i < listStatus.length; i++) {
          if (listStatus[i].text === status) uuidStatus = listStatus[i].value
        }
        axios.patch(this.apiUrl + '/' + row.uuid,
          {
            facilityBookingStatus: uuidStatus,
            bookingNote: note
          }
        )
          .then(response => {
            this.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + status + '</b>')
            row.facilityBookingStatus = status
          })
          .catch(error => {
            this.$store.dispatch('errorMessage', error)
              .then(errMsg => {
                this.$alertify.error(errMsg)
              })
          })
      }
    },
    doConfirmRejectingBooking (row) {
      this.$alertify.prompt('Reject Note <span style="color:red">*</span>', '',
        (evt, value) => this.doBookingApproval(row, 'Rejected', value)
      )
    },

    goBack () {
      window.goBack(this)
    },
    goToDetail (uuid) {
      this.$router.push('/settings/user/contractors/' + uuid)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/settings/tenant/Detail.vue